<template>
    <div class="index-layout-wrap">
        <!--        布局头部-->
        <div class="index-layout-wrap-header">
            <!--        头部LOGO-->
            <div class="index-layout-wrap-header_logo">
              <logo />
            </div>
            <!--            横向菜单区域-->
            <div class="index-layout-wrap-header_menu"></div>
            <!--        用户信息-->
            <div class="index-layout-wrap-header_user">
                <j-avatar />
            </div>
        </div>
        <!--        布局内容区域-->
        <div class="index-layout-wrap-content">
            <!--            左侧菜单区域-->
            <div class="index-layout-wrap-content_menu">
                <j-menu />
            </div>
            <!--            右侧切换区域-->
            <div class="index-layout-wrap-content_page">
                <!--                快速访问栏-->
                <div class="index-layout-wrap-content_page__tab">
                    <j-quick-tab/>
                </div>
                <!--                动态组件加载区-->
                <div class="index-layout-wrap-content_page__component">
                    <transition name="index-transition-page" mode="out-in">
                        <keep-alive :include="$store.state.JMenu.menuCache" :exclude="[...$store.state.JMenu.menuDestroy, ...$store.state.LedgerConfig.ledgerConfigExcludeMenus]">
                            <router-view v-if="deliverModel === 'router'" />
                            <component v-else :is="$store.state.JMenu.menuActive" />
                        </keep-alive>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import JAvatar from "../../components/JComponents/JAvatar/JAvatar";
    import JMenu from "../../components/JComponents/JMenu/JMenu";
    import JQuickTab from "../../components/JComponents/JQuickTab/JQuickTab";
    import { deliverModel } from "../../config";
    import Logo from "@/components/Logo.vue";

    export default {
        name: "Home",
        components: {
            Logo,
            JAvatar,
            JMenu,
            JQuickTab
        },
        data () {
            return {
                deliverModel
            }
        },
        created() {
            this.$store.dispatch('getUserList') // 获取缓存用户列表
            // this.$store.dispatch('getOrgTree') // 获取缓存机构树
        }
    }
</script>

<style scoped lang="scss">
    .index-layout-wrap {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .index-layout-wrap-header {
            height: 60px;
            box-sizing: border-box;
            display: flex;
            background-color: #F6F8FB;
            /*background-image: url("../../assets/header-bg.png");*/
            background-repeat: no-repeat;
            background-size: auto 100%;
            border-bottom: 2px solid #2CA2F2;

            .index-layout-wrap-header_logo {
                font-size: 20px;
                font-weight: bolder;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 404px;
                margin-left: 20px;
                /*background-image: url("../../assets/header-text.png");*/
                background-size: cover;
            }

            .index-layout-wrap-header_menu {
                flex: 1;
                min-width: 100px;
            }

            .index-layout-wrap-header_user {
                width: 180px;
                padding-right: 30px;
                box-sizing: border-box;
            }
        }

        .index-layout-wrap-content {
            flex: 1;
            min-height: 200px;
            display: flex;

            .index-layout-wrap-content_menu {
                max-width: 208px;
            }

            .index-layout-wrap-content_page {
                flex: 1;
                min-width: 100px;
                background-color: #F6F8FB;
                display: flex;
                flex-direction: column;

                .index-layout-wrap-content_page__tab {
                    height: 40px;
                }

                .index-layout-wrap-content_page__component {
                    flex: 1;
                    min-height: 100px;
                    box-sizing: border-box;
                    margin: 16px 16px;
                    background-color: #fff;
                    border-radius: 5px;
                    overflow: hidden;
                }
            }
        }
    }
</style>

<style>
    html, body {
        height: 100%;
    }

    .index-transition-page-leave-active,
    .index-transition-page-enter-active {
        transition: all 300ms linear;
        width: 100%;
        height: 100%;
    }

    .index-transition-page-enter,
    .index-transition-page-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
